import { ref } from "vue";
import { usePlantings } from "seedgreen-shared/queries/planting";
import { getDefaultPlantingQueryRange } from "@/utils/planting";

export function useDefaultPlantingsQuery() {
	const plantingQueryStart = ref(getDefaultPlantingQueryRange().start);
	const plantingQueryEnd = ref(getDefaultPlantingQueryRange().end);

	const { plantings, ...rest } = usePlantings({
		finalDateAfter: plantingQueryStart,
		wetDateBefore: plantingQueryEnd,
	});

	return {
		plantings,
		plantingQueryStart,
		plantingQueryEnd,
		...rest,
	};
}
